import { render } from "./ali.vue?vue&type=template&id=36fd21ee&scoped=true"
import script from "./ali.vue?vue&type=script&lang=js"
export * from "./ali.vue?vue&type=script&lang=js"

import "./ali.vue?vue&type=style&index=0&id=36fd21ee&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fd21ee"]])

export default __exports__